'use strict';
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
const react_1 = __importDefault(require('react'));
const useSubmitHandler_1 = __importDefault(
  require('../hooks/useSubmitHandler')
);
function PostForm(props) {
  const { action, children, formDataType, onSuccess } = props,
    extraProps = __rest(props, [
      'action',
      'children',
      'formDataType',
      'onSuccess',
    ]);
  const onSubmitHandler = (0, useSubmitHandler_1.default)({
    formDataType: formDataType || 'formData',
    onSubmit: values =>
      __awaiter(this, void 0, void 0, function* () {
        let body;
        if (!(values instanceof FormData)) {
          body = JSON.stringify(values);
        } else {
          body = values;
        }
        return fetch(action, {
          body: body,
          method: 'POST',
        }).then(r =>
          __awaiter(this, void 0, void 0, function* () {
            const response = yield r.json();
            if (r.status !== 200) throw new Error(response.error);
            return response;
          })
        );
      }),
    onSuccess,
  });
  return react_1.default.createElement(
    'form',
    Object.assign({}, extraProps, {
      noValidate: true,
      onSubmit: onSubmitHandler,
    }),
    children
  );
}
exports.default = PostForm;
//# sourceMappingURL=PostForm.js.map
